/* @flow weak */
export default [
  { value: '', label: '[No title]' },
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Coach', label: 'Coach' },
  { value: 'Prof.', label: 'Prof.' },
];



// WEBPACK FOOTER //
// ./src/lib/Prefixes.js